export abstract class IAccountOrganizationsDAO {
    public abstract getAccountOrganizations(accountId: number): Promise<IAccountOrganizationDTO[]>;
    public abstract createAccountOrganization(accountId: number, params: ICreateAccountOrganizationDTO): Promise<IAccountOrganizationDTO>;
}

export interface ICreateAccountOrganizationDTO {
    name: string;
}

export interface IAccountOrganizationDTO {
    accountOrganizationId: number;
    name: string;
}